<template src="./addcompanychecktemplate.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import { required } from "vuelidate/lib/validators";

  export default {
    components: {},
    filters: {},
    data() {
      return {
      	ClassId: 0,
        FleetSubscription: {},
        CountAssetTemplateChecks: 0,
        ShowLoader: false,
        Editmode: false,
        Submitted: false,
        TemplateExists: false,
        ShowAssetTemplatesPopup:false,
        CountCustomAssetCheck:0,
        ClassList: [],
        AssetTemplates: [],        
        NewTemplate: {
          class_id: "",          
          name: "",
          CompanyCheckTemplateChecks: [],
        },
        CopyTemplate: {
          asset_template_id: ""
        },
        CompanyChecks: [],
      };
    },
    validations: {
      NewTemplate: {
        name: { required },
        class_id: { required },        
      },
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.ClassId = this.$route.params.ClassId;
      this.NewTemplate.class_id = this.ClassId
      this.GetCompanySubscription();
      this.GetClassList();
      this.GetCompanyChecks(this.ClassId);
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
    },
    methods: {
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isAssets = FleetSubscriptionModules.Assets;
        if (isAssets) {
        } else {
          this.$router.push("/settings");
        }
      },
      GetClassList() {
        Axios.post(Endpoints.VehicleChecks.GetVehicleClassList, {
          token: localStorage.getItem("token"),
        }).then((Response) => {        	
          if (Response?.data?.success) {
            this.ClassList = Response.data.records;
          }
        });
      },
      GetCompanyChecks(catID) {
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleChecks.GetCompanyChecks, {
          token: localStorage.getItem("token"),
          vehicle_class_id: catID,
        }).then((Response) => {
          this.ShowLoader = false;
          this.CompanyChecks = Response.data.CompanyChecks;
          this.CompanyChecks[0]["required"] = true;
          /*this.CompanyChecks.forEach((value, index) => {
          	this.CompanyChecks[index]['id']=0
          })*/
          this.NewTemplate.CompanyCheckTemplateChecks = this.CompanyChecks          
          this.CountAssetChecks();
        });
      },            
      CountAssetChecks() {
        this.CountAssetTemplateChecks = this.NewTemplate.CompanyCheckTemplateChecks.length;
      },      
      SaveVehicleCheckTemplate(SaveType = "Add") {
        this.Submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.TemplateExists = false;
        var error = false;
        this.NewTemplate.CompanyCheckTemplateChecks.forEach((element) => {
          if (element.id == 0) {
            if (element.name == "") {
              error = true;
              this.$swal("Please Enter Check Name", "", "error");
              this.Submitted = false;
              return true;
            }
          }
        });        
        if (!error) {
          this.Submitted = true;
          this.NewTemplate['SaveType'] = SaveType;
          Axios.post(Endpoints.VehicleCheckTemplate.Template.Create, {
            token: localStorage.getItem("token"),
            ...this.NewTemplate,
          }).then((Response) => {
            if(Response?.data?.success == true){
            this.Submitted = false;
            this.$swal(
              "Template Saved Successfully",
              "",
              "success"
            ).then(() => {
              this.$router.push("/settings/company-check/templates/"+this.ClassId);
            });
          }else{
            this.Submitted = false;
            if(Response.data.template_exists){
              this.$swal({
              title: "Alert!",
              
              html: `
              Template already exits for this sub category.<br /><br />
              <button class="swal2-confirm swal2-styled swal2-default-outline" id="replace-button">Replace</button>
              <button class="swal2-confirm swal2-styled swal2-default-outline" id="merge-button">Merge</button>
            `,
              icon: "warning",
              showCancelButton: true,
              showConfirmButton: false,
              confirmButtonColor: "#514b71",
              cancelButtonColor: "#aaa",
              cancelButtonText: "Ok",
              reverseButtons: false,
            });
            document.getElementById('replace-button').addEventListener('click', () => {
              this.SaveAssetTemplate("Replace");
                this.$swal.close();
              });

              document.getElementById('merge-button').addEventListener('click', () => {
                this.SaveAssetTemplate("Merge");
                this.$swal.close();
              });
            }else{
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          }
          });
        }
      },
      DeleteTemplateCheck(tempid) {
        this.$swal({
          title: "Are you sure You want to delete this Check Record?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.NewTemplate.CompanyCheckTemplateChecks.forEach((value, index) => {
                if (value.id == tempid) {
                  this.NewTemplate.CompanyCheckTemplateChecks.splice(index, 1);
                }
              });
              this.$swal(
                "Asset Template Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
              });
          }
        });
      },
      AddCustomTemplateCheck() {

        /*if (
          this.FleetSubscription &&
          this.FleetSubscription.allowed_total_asset_checks >
            this.CountAssetTemplateChecks
        ) {*/

          this.Editmode = true;
          var obj = {
            custom: 1,
            id: 0,
            name: "",
            description: "",
            fleet_asset_template_id: 0,
            position: this.NewTemplate.CompanyCheckTemplateChecks.length + 1,
            required: 0,
            status: 1,
          };
          this.NewTemplate.CompanyCheckTemplateChecks.push(obj);
          this.CountAssetChecks();
        /*}else {
          this.$swal(
            "You have reached your subscription's maximum allowed asset checks. Please contact us to add more checks",
            "",
            "error"
          );
        }*/
      },
    },
  };
</script>

<style type="text/css"></style>
